'use strict';

var React = require('react');

var SvgPromoteMinor = function SvgPromoteMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 9.75a2.643 2.643 0 0 1 2.496-2.639l3.793-.21a1 1 0 0 0 .492-.162l4.546-2.976a1 1 0 0 1 1.548.837v3.185a2 2 0 0 1 0 3.93v3.185a1 1 0 0 1-1.548.837l-4.189-2.742-.29 2.46a1.75 1.75 0 0 1-1.737 1.545h-.361a1.75 1.75 0 0 1-1.75-1.75v-2.833l-.504-.028a2.643 2.643 0 0 1-2.496-2.639Zm2.58-1.141a1.143 1.143 0 0 0 0 2.282l3.792.21c.438.025.863.164 1.23.405l3.773 2.47v-8.451l-3.773 2.469a2.5 2.5 0 0 1-1.23.404l-3.793.211Zm1.92 3.891v2.75c0 .138.112.25.25.25h.36a.25.25 0 0 0 .249-.22l.32-2.714-1.179-.066Z"
  }));
};
SvgPromoteMinor.displayName = "PromoteMinor";

exports.SvgPromoteMinor = SvgPromoteMinor;
